import { useState, useEffect } from 'react';
import resolveBytescaleVideoUrl from '../util/bytescaleVideo';
import { getBytescaleVideoURLSync } from '../util/bytescale';

/**
 * Hook to handle async video processing with Bytescale
 * Returns the processed video URL when available, with loading and error states
 */
function useProcessedVideo(videoPath, enableProcessing = true) {
  const [videoUrl, setVideoUrl] = useState(() => {
    // Start with sync URL for immediate rendering
    return videoPath ? getBytescaleVideoURLSync(videoPath) : null;
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!videoPath || !enableProcessing) {
      return undefined;
    }

    let isCancelled = false;

    const processVideo = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const processedUrl = await resolveBytescaleVideoUrl(videoPath);

        if (!isCancelled) {
          setVideoUrl(processedUrl);
          setIsLoading(false);
        }
      } catch (err) {
        if (!isCancelled) {
          setError(err);
          setIsLoading(false);
        }
      }
    };

    processVideo();

    return () => {
      isCancelled = true;
    };
  }, [videoPath, enableProcessing]);

  return {
    videoUrl,
    isLoading,
    error,
  };
}

export default useProcessedVideo;
